export * from './info-default-separation'
